import * as z from 'zod'
import { USER_EVENT_TYPES } from '../UserEvents.js'
import { PostApiContract } from './ApiContract.js'

export const postUserEventSchema = z.looseObject({
    // Use looseObject to allow unknown properties
    eventType: z.enum(Object.values(USER_EVENT_TYPES)),
})

export interface PostUserEventRequest extends PostApiContract {
    Body: z.infer<typeof postUserEventSchema>
    Response: object
}
